import {
  type CreatePlacesAddMyPlaceBody,
  useCreatePlacesAddMyPlace,
  useGetAuthMe,
} from "@birdwatch/client";

import { useRefresh } from "@/features/shared/realtime-refresh";

export type AddPlaceInput = CreatePlacesAddMyPlaceBody;

/**
 * Adds a place to the member: the home, their link to it, its purchase intent
 * and their account's referral record — what the route announces.
 */
export const useAddPlace = () => {
  const refresh = useRefresh();
  const { data: me } = useGetAuthMe().get();

  return useCreatePlacesAddMyPlace({
    mutationKey: ["add-place"],
    onSuccess: ({ placeId, purchaseIntentId }) => {
      const accountId = me?.accounts?.[0]?.id;
      void Promise.all([
        // A household change refreshes the home's own reads too (`place.changed`'s set).
        refresh("household.changed", { placeId }),
        refresh("purchaseIntent.changed", { purchaseIntentId }),
        me?.id ? refresh("user.changed", { userId: me.id }) : undefined,
        accountId ? refresh("account.changed", { accountId }) : undefined,
      ]);
    },
  });
};
